import { render } from "./TotalHoras.vue?vue&type=template&id=1ef0a325"
import script from "./TotalHoras.vue?vue&type=script&lang=js"
export * from "./TotalHoras.vue?vue&type=script&lang=js"

import "./TotalHoras.vue?vue&type=style&index=0&id=1ef0a325&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__